import React from 'react';
import PropTypes from 'prop-types';
import './customScrollableList.scss';
import { TARGET_FIELDS_PROP_TYPE } from 'shared/constants/PropTypes';

const CustomScrollableList = ({ id, className, items, onItemClick, surroundField }) => (
  <div id={ id } className={ `custom-scrollable-list ${className}` }>
    <ul>
      { items.map(item => <li key={ item.name } onClick={ () => onItemClick(surroundField ? `[${item.name}]` : item.name) }>{ item.label }</li>) }
    </ul>
  </div>
);

CustomScrollableList.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  items: TARGET_FIELDS_PROP_TYPE.isRequired,
  onItemClick: PropTypes.func,
  surroundField: PropTypes.bool
};

CustomScrollableList.defaultProps = {
  className: '',
  onItemClick: () => null,
  surroundField: false
};

export default CustomScrollableList;



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/comp/customScrollableList/CustomScrollableList.js